import { Drawer } from '@/components/ui'
import { useUiStore } from '@/stores'
import { Sidebar } from './Sidebar'
import { TenantSwitcher } from './TenantSwitcher'
import { ThemeToggle } from './ThemeToggle'

/**
 * The sidebar as a left drawer, below lg.
 *
 * Navigating closes it — a nav drawer left open over the page the user just
 * asked for is the most common mobile-nav bug there is. It also hosts the
 * tenant switcher and theme toggle, which the top bar hides at that width.
 */
export function MobileNav() {
  const isOpen = useUiStore((s) => s.isMobileNavOpen)
  const setOpen = useUiStore((s) => s.setMobileNavOpen)

  return (
    <Drawer
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      side="left"
      width="sm"
      className="lg:hidden"
      footer={
        <div className="flex items-center justify-between gap-2">
          <TenantSwitcher />
          <ThemeToggle />
        </div>
      }
    >
      <Sidebar onNavigate={() => setOpen(false)} forceExpanded />
    </Drawer>
  )
}
